// extracted by mini-css-extract-plugin
export default {"OrderFooter":"OrderCreatePage_OrderFooter__tUgJC","ButtonRow":"OrderCreatePage_ButtonRow__c84+r","Modal":"OrderCreatePage_Modal__o6eSK"};